// extracted by mini-css-extract-plugin
export default {"bottomNavigation":"styles_bottomNavigation__rVqgh","travelsIcon":"styles_travelsIcon__--MHV","etherIcon":"styles_etherIcon__zQhYI","isDisabledMenu":"styles_isDisabledMenu__M+1-k"};